import ttt from './initializedTtt';
import { defaultProps } from 'recompose';

const withPageviewTracker = defaultProps({
  pageviewTrack: (pageName, contextData = {}) => {
    const propChannel = 'wbm/Welcome';
    ttt.pageview(propChannel, pageName, contextData);
  },
});

export default withPageviewTracker;
